<template>
  <div class="home min-h">
    <header-view :tabsign="5"></header-view>
    <div class="body">
	  <div class="toptitle">
	  	<div class="left_c">
	  		<div class="redcon"></div>
	  		<span>公示公告</span>
	  	</div>
	  	<div class="right_c"></div>
	  </div>
	  
      <div class="noticeDetailstitle">{{ Institutional.titile == undefined?'':Institutional.titile}}</div>
      <div class="subtitle">
        <!-- <span>作者：{{Institutional.createBy == undefined?'':Institutional.createBy}}</span> -->
        <span> 发布时间：{{Institutional.sendTime == undefined?'':Institutional.sendTime}}</span>
        <!-- <span>阅读：{{Institutional.views == undefined?'':Institutional.views}}</span> -->
      </div>
      <div v-html="Institutional.msgContent" class="msg" style="margin-bottom: 100px;"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Institutional",

  data: function() {
    return {
      Institutional: "",
      query: ""
    };
  },
  created() {
    this.query = this.$route.query;
	  this.init();
  },
  mounted() {
    this.add();
    window.pageYOffset = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;	
  },
  methods: {
    init() {
      var that = this;
      this.httpPut("web/annountCement/getById", {
        id: this.query.id
      }).then(res => {
        that.Institutional = res.result;
      });
    },
    add() {
      this.httpPut("web/annountCement/eidtViews", {
        id: this.query.id
      });
    }
  }
};
</script>
<style scoped lang="scss">
.home {
  ::-webkit-scrollbar { width: 0 !important }
  width: 100%;
  position: relative;
  .body {
    width: 1200px;
    background: #ffffff;
    margin: 120px auto 0;
	.toptitle{
		height: 60px;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 5px;
				height: 20px;
				background: #E70012;
				margin-right: 20px;
			}
			font-size: 25px;
			font-weight: 400;
			color: #E61F26;
		}
		.right_c{
			
		}
	}
    .noticeDetailstitle {
      margin-top:17px;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
    .subtitle {
      text-align: center;
      margin-top: 21px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      span {
        display: inline-block;
        margin-right: 40px;
        margin-bottom: 45px;
      }
    }
    .msg {
      width: 1040px;
      margin: 0 auto;
    }
  }
}
</style>
